import { ApolloClient } from '@apollo/client'
import { useApolloClient } from '@apollo/client'

/**
 * Custom hook to refetch specified GraphQL queries
 * @param queries Array of query names to refetch
 * @returns Function that when called will refetch active queries from the provided list
 */
const useRefetchQueries = (queries: string[]) => {
  const client = useApolloClient()

  const refetch = () => {
    return client.refetchQueries({
      include: getIfActive({
        apolloClient: client,
        queries,
      })
    })
  }

  return refetch
}

const getIfActive = ({
  apolloClient,
  queries,
}: {
  apolloClient: ApolloClient<unknown>
  queries: string[]
}) => {
  const activeQueriesNames = Array.from(apolloClient.getObservableQueries('active').values()).map(
    (obsQuery) => obsQuery.queryName
  )

  return queries.filter((queryName) => activeQueriesNames.includes(queryName))
}

export { getIfActive, useRefetchQueries }
